import { type ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';

// Banner shown inside the /redemption screen explaining the earnings
// penalty. Uses brand-red (no yellow) to match the rest of the redemption
// flow.
export function RedemptionStatusBanner(): ReactNode {
  return (
    <div
      role="status"
      className="flex items-start gap-sm rounded-lg border border-brand-red/40 bg-brand-red/10 px-base py-sm text-brand-red backdrop-blur-xl"
    >
      <AlertTriangle size={16} className="mt-0.5 shrink-0" />
      <p className="flex-1 text-[11px] leading-relaxed sm:text-sm">
        No hay ganancias durante esta redención. Todos los creadores que añadas
        cuentan para llegar a 99, pero no generan dinero.
      </p>
    </div>
  );
}
